export default "__VITE_ASSET__1f96d899__"